import CaptureRecord from './CaptureRecord.vue'
export default CaptureRecord



// WEBPACK FOOTER //
// ./src/views/system/captureRecord/index.js